import React, { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import { Layout } from "../component/Common";
import { Loading } from "../component/ui";
import Auth from "../pages/Auth";
import BusinessModel from "../pages/BusinessModel";
import PageNotFound from "../pages/PageNotFound";
import MultiStepForm from "../pages/MultiStepForm";
import Graph from "../pages/Graph";
import TeamDetail from "../pages/TeamDetail";
import NONPTSuvery from "../pages/NONPTSuvery";

import Scale from "../pages/Scale";
import { ItemsContext } from "../data/context";
import DemoSuccess from "../pages/DemoSuccess";
import Disclaimer from "../pages/Disclaimer";
import FounderNotes from "../pages/FounderNotes";
import SurveyStart from "../pages/Share/SurveyStart";
import Contact from "../pages/Contact";
import Demo from "../pages/Demo";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import CookiePolicy from "../pages/CookiePolicy";
import TermsConditions from "../pages/TermsConditions";
import Home from "../pages/Home";
import SocialMedia from "../pages/SocialMedia";
import DocumentationPhysicalTherapy from "../pages/Blogs/DocumentationPhysicalTherapy";
import AdvocacyReimbursement from "../pages/Blogs/AdvocacyReimbursement";
import AIHealthcareBias from "../pages/Blogs/AIHealthcareBias";
import SessionWroteNote from "../pages/Blogs/SessionWroteNote";
import ProvingOutcomesFuturePT from '../pages/Blogs/ProvingOutcomesFuturePT';
import WhyNotPTFirst from '../pages/Blogs/WhyNotPTFirst';
import AISoapNotes from '../pages/Blogs/AISoapNotes';
import Top5AINoteTakingTools from '../pages/Blogs/Top5AINoteTakingTools';
import AIScribesHealthcare from '../pages/Blogs/AIScribesHealthcare';
import FutureOfDocumentation from '../pages/Blogs/FutureOfDocumentation';
import AIScribeVsRealtime from '../pages/Blogs/AIScribeVsRealtime';
import WhyNotation from '../pages/Blogs/WhyNotation';
import Instagram from '../pages/Instagram';
import AboutUs from "../pages/About";
import RoiCalculator from "../pages/RoiCalculator";
import DetailedRoiCalculator from "../pages/DetailedRoiCalculator";
import NotationPage from "../pages/Notation";
import FAQ from "../pages/FAQ";
import Careers from "../pages/Careers";
import JobApplication from "../pages/JobApplication";
import PTSalesRepApplication from "../pages/PTSalesRepApplication";

const AppRoutes = () => {
  const isMobile = () => {
    if (window.innerWidth >= 768) {
      return true;
    } else {
      return false;
    }
  };

  const { setIsPolicyModelOpen } = useContext(ItemsContext);

  const policyCheck = localStorage.getItem("fownd-policy");
  console.log(policyCheck, "policyCheck");
  if (policyCheck == null) {
    setIsPolicyModelOpen(true);
  }

  return (
    <>
      <Routes>
        <Route
          path="*"
          element={
            <React.Suspense fallback={<Loading />}>
              <PageNotFound />
            </React.Suspense>
          }
        />
        <Route element={<Layout />}>
          <Route
            path="/auth"
            element={
              <React.Suspense fallback={<Loading />}>
                <Auth />
              </React.Suspense>
            }
          />
        </Route>

        <Route element={<Layout darkMenu={true} />}>
          <Route
            path="/"
            element={
              <React.Suspense fallback={<Loading />}>
                {/* <LandingPage /> */}
                <Home />
              </React.Suspense>
            }
          />
        </Route>

        <Route element={<Layout />}>
          <Route
            path="/business-model"
            element={
              <React.Suspense fallback={<Loading />}>
                <BusinessModel />
              </React.Suspense>
            }
          />
        </Route>
        <Route element={<Layout />}>
          <Route
            path="/demo"
            element={
              <React.Suspense fallback={<Loading />}>
                <Demo />
              </React.Suspense>
            }
          />
        </Route>
        <Route element={<Layout />}>
          <Route
            path="/disclaimer"
            element={
              <React.Suspense fallback={<Loading />}>
                <Disclaimer />
              </React.Suspense>
            }
          />
        </Route>
        <Route element={<Layout />}>
          <Route
            path="/survey-confirm"
            element={
              <React.Suspense fallback={<Loading />}>
                <DemoSuccess />
              </React.Suspense>
            }
          />
        </Route>
        <Route
          path="/survey"
          element={
            <React.Suspense fallback={<Loading />}>
              <MultiStepForm />
            </React.Suspense>
          }
        />
        <Route element={<Layout />}>
          <Route
            path="/non-pt-survey"
            element={
              <React.Suspense fallback={<Loading />}>
                <NONPTSuvery />
              </React.Suspense>
            }
          />
        </Route>
        <Route element={<Layout darklightMenu={true} />}>
          <Route
            path="/success"
            element={
              <React.Suspense fallback={<Loading />}>
                <Graph />
              </React.Suspense>
            }
          />
        </Route>
        <Route element={<Layout darkMenu={isMobile()} />}>
          <Route
            path="/about"
            element={
              <React.Suspense fallback={<Loading />}>
                <AboutUs />
              </React.Suspense>
            }
          />
        </Route>
        <Route element={<Layout darkMenu={isMobile()} />}>
          <Route
            path="/faq"
            element={
              <React.Suspense fallback={<Loading />}>
                <FAQ />
              </React.Suspense>
            }
          />
        </Route>
        <Route element={<Layout darkMenu={true} />}>
          <Route
            path="/careers"
            element={
              <React.Suspense fallback={<Loading />}>
                <Careers />
              </React.Suspense>
            }
          />
          <Route
            path="/careers/computer-vision-engineer"
            element={
              <React.Suspense fallback={<Loading />}>
                <JobApplication />
              </React.Suspense>
            }
          />
          <Route
            path="/careers/pt-pta-sales-rep"
            element={
              <React.Suspense fallback={<Loading />}>
                <PTSalesRepApplication />
              </React.Suspense>
            }
          />
        </Route>
        <Route element={<Layout darkMenu={true} />}>
          <Route
            path="/notation"
            element={
              <React.Suspense fallback={<Loading />}>
                <NotationPage />
              </React.Suspense>
            }
          />
        </Route>
        <Route element={<Layout darkMenu={true} />}>
          <Route
            path="/blogs"
            element={
              <React.Suspense fallback={<Loading />}>
                <SocialMedia />
              </React.Suspense>
            }
          />
          <Route
            path="/blogs/documentation-physical-therapy"
            element={
              <React.Suspense fallback={<Loading />}>
                <DocumentationPhysicalTherapy />
              </React.Suspense>
            }
          />
          <Route
            path="/blogs/advocacy-reimbursement"
            element={
              <React.Suspense fallback={<Loading />}>
                <AdvocacyReimbursement />
              </React.Suspense>
            }
          />
          <Route
            path="/blogs/ai-healthcare-bias"
            element={
              <React.Suspense fallback={<Loading />}>
                <AIHealthcareBias />
              </React.Suspense>
            }
          />
          <Route
            path="/blogs/session-wrote-note"
            element={
              <React.Suspense fallback={<Loading />}>
                <SessionWroteNote />
              </React.Suspense>
            }
          />
          <Route
            path="/blogs/proving-outcomes-future-pt"
            element={
              <React.Suspense fallback={<Loading />}>
                <ProvingOutcomesFuturePT />
              </React.Suspense>
            }
          />
          <Route
            path="/blogs/why-not-pt-first"
            element={
              <React.Suspense fallback={<Loading />}>
                <WhyNotPTFirst />
              </React.Suspense>
            }
          />
          <Route
            path="/blogs/ai-soap-notes-pt-guide-2025"
            element={
              <React.Suspense fallback={<Loading />}>
                <AISoapNotes />
              </React.Suspense>
            }
          />
          <Route
            path="/blogs/top-5-ai-note-taking-tools-pt-clinics"
            element={
              <React.Suspense fallback={<Loading />}>
                <Top5AINoteTakingTools />
              </React.Suspense>
            }
          />
          <Route
            path="/blogs/ai-scribes-healthcare-notation-physical-therapy-future"
            element={
              <React.Suspense fallback={<Loading />}>
                <AIScribesHealthcare />
              </React.Suspense>
            }
          />
          <Route
            path="/blogs/ai-documentation-follows-visit-not-form"
            element={
              <React.Suspense fallback={<Loading />}>
                <FutureOfDocumentation />
              </React.Suspense>
            }
          />
          <Route
            path="/blogs/ai-scribe-vs-realtime-documentation"
            element={
              <React.Suspense fallback={<Loading />}>
                <AIScribeVsRealtime />
              </React.Suspense>
            }
          />
          <Route
            path="/blogs/why-notation-more-than-ai-scribe"
            element={
              <React.Suspense fallback={<Loading />}>
                <WhyNotation />
              </React.Suspense>
            }
          />
          <Route
            path="/instagram"
            element={
              <React.Suspense fallback={<Loading />}>
                <Instagram />
              </React.Suspense>
            }
          />
        </Route>

        <Route element={<Layout darkMenu={true} />}>
          <Route
            path="/contact"
            element={
              <React.Suspense fallback={<Loading />}>
                <Contact />
              </React.Suspense>
            }
          />
        </Route>

        <Route element={<Layout darkMenu={false} />}>
          <Route
            path="/help-scale"
            element={
              <React.Suspense fallback={<Loading />}>
                <Scale />
              </React.Suspense>
            }
          />
        </Route>

        <Route element={<Layout darkMenu={true} />}>
          <Route
            path="/founder-notes"
            element={
              <React.Suspense fallback={<Loading />}>
                <FounderNotes />
              </React.Suspense>
            }
          />
        </Route>
        <Route element={<Layout darkMenu={true} />}>
          <Route
            path="/team/:name"
            element={
              <React.Suspense fallback={<Loading />}>
                <TeamDetail />
              </React.Suspense>
            }
          />
        </Route>

        <Route
          path="/start-survey"
          element={
            <React.Suspense fallback={<Loading />}>
              <SurveyStart />
            </React.Suspense>
          }
        />

        <Route
          path="/privacy-policy"
          element={
            <React.Suspense fallback={<Loading />}>
              <PrivacyPolicy />
            </React.Suspense>
          }
        />
        <Route
          path="/cookie-policy"
          element={
            <React.Suspense fallback={<Loading />}>
              <CookiePolicy />
            </React.Suspense>
          }
        />

        <Route
          path="/terms-conditions"
          element={
            <React.Suspense fallback={<Loading />}>
              <TermsConditions />
            </React.Suspense>
          }
        />

        <Route element={<Layout />}>
          <Route
            path="/roi-calculator"
            element={
              <React.Suspense fallback={<Loading />}>
                <RoiCalculator />
              </React.Suspense>
            }
          />
          <Route
            path="/detailed-roi-calculator"
            element={
              <React.Suspense fallback={<Loading />}>
                <DetailedRoiCalculator />
              </React.Suspense>
            }
          />
        </Route>
      </Routes>
    </>
  );
};

export default AppRoutes;
